<template>
  <v-layout row wrap class="mt-2">
    <v-flex xs12>
      <v-title>Training Resources</v-title>
      <v-btn
        v-for="(item, index) in links"
        :key="index"
        color="primary"
        @click="openLink(item.url)"
      >
        {{ item.label }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'TrainingList',

  data() {
    return {
      links: null,
    };
  },
  methods: {
    ...mapActions('orders', ['getTrainingLinks', 'sendSQRequest']),
    openLink(url) {
      window.open(url, '_blank');
    },
    loadPage() {
      let vm = this;
      vm.getTrainingLinks()
        .then((data) => {
          vm.links = data;
        })
        .catch(() => {});
    },
  },
};
</script>
